import React, { useState } from 'react'
import style from './style'
import propTypes from './prop'
import { withStyles, Grid, MenuItem, Menu } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { CoreButton, CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
/**
 *
 * @param {*} props
 */
const GrupActions = props => {
  const { classes, actions, executeAction, selectedCount } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const accessValue = collectionSettings?.accessRule

  /**
   *
   * @param {*} action
   */
  const handleAction = action => {
    executeAction(action)

    handleMenuClose()
  }

  /**
   *
   * @param {*} action
   */
  const handleMenuClose = event => {
    setAnchorEl(null)
  }
  /**
   *
   * @param {*} action
   */
  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  /**
   *
   * @param {*} action
   */
  const renderButton = action => {
    return (
      <CoreButton
        className={classes.action}
        color={action.color ? action.color : 'primary'}
        variant={action.variant ? action.variant : 'contained'}
        size="small"
        onClick={e => {
          handleAction(action)
        }}
        disabled={action.disabled(selectedCount)}
        startIcon={action.icon && action.icon}
      >
        {action.label}
      </CoreButton>
    )
  }
  /**
   *
   * @param {*} group
   */
  const renderSelect = group => {
    return (
      <React.Fragment>
        <CoreIconButton onClick={handleMenuOpen} color="dark" variant="text">
          <Icon icon={'eva:more-vertical-fill'} />
        </CoreIconButton>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {group.items.map((action, index) => {
            if (
              action.hidden === 'returnFalseIfAccessValueIs2' &&
              accessValue !== 2
            ) {
              return null
            }
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  handleAction(action)
                }}
              >
                {action.label}
              </MenuItem>
            )
          })}
        </Menu>
      </React.Fragment>
    )
  }
  return (
    <Grid className={classes.buttonsGrid}>
      {actions.map((action, index) => {
        let element = null
        if (action.items.length === 1) {
          element = renderButton(action.items[0])
        } else if (action.items.length === 0) {
          element = null
        } else {
          /*if (selectedCount > 0) */
          element = renderSelect(action)
        }

        return <React.Fragment key={index}>{element}</React.Fragment>
      })}
    </Grid>
  )
}

GrupActions.propTypes = propTypes

export default withStyles(style)(GrupActions)
